import { Tooltip, withStyles } from "@material-ui/core";

const CustomTooltip = withStyles(() => ({
  tooltip: {
    fontSize: "14px",
  },
}))(Tooltip);

export default CustomTooltip;
